// Component
import { Header as HeaderBase } from '@/components/layout';

// Constants
import { IMAGES, ROUTES } from '@shared/constants';
export const MainHeader = () => <HeaderBase logo={{
  src: {
    lightMode: IMAGES.LOGO_AGILITY
  },
  alt: 'Logo of the application',
  width: 102,
  height: 26
}} className="bg-white px-0 mx-0 flex items-center justify-between h-header-sm" classCustom="mx-0 px-6 py-0 md:px-7.5" href={ROUTES.SIGN_IN} data-sentry-element="HeaderBase" data-sentry-component="MainHeader" data-sentry-source-file="Header.tsx" />;